import PropTypes from 'prop-types';
import Spinner from './spinner';
import './style.css';

const Loading = ({ message = 'Loading...' }) => (
  <div className="loader">
    <Spinner />
    <p className="loader__text">{message}</p>
  </div>
);

Loading.propTypes = {
  message: PropTypes.string,
};

export default Loading;
